import styled from 'styled-components'

export const TopBarContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
`

export const LeftSection = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  gap: 12px;
`

export const RightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const ActiveFiltersRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 16px;
`

export const FilterSection = styled.div`
  background: #fafafa;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
`

export const FilterSectionTitle = styled.div`
  font-size: 12px;
  font-weight: bold;
  color: #00a0a8;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 16px;
`

export const FilterGroup = styled.div`
  margin-bottom: 16px;

  &:last-child {
    margin-bottom: 0;
  }
`

export const FilterLabel = styled.div`
  font-size: 13px;
  font-weight: 500;
  color: #333;
  margin-bottom: 6px;
`

export const DrawerFooter = styled.div`
  padding: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
`

export const ReviewBanner = styled.button<{ $active: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  text-align: left;
  cursor: pointer;
  border: 1px solid ${({ $active }) => ($active ? '#f5d9a8' : '#f3e2c7')};
  background: ${({ $active }) => ($active ? '#fdf3e3' : '#fdf6ec')};
  color: #8a6d3b;
  border-radius: 8px;
  padding: 10px 16px;
  margin-bottom: 16px;
  font-size: 13px;
  transition: background 0.15s ease;

  &:hover:not(:disabled) {
    background: #fdf3e3;
  }

  &:focus-visible {
    outline: 2px solid #f5d9a8;
    outline-offset: 2px;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.7;
  }
`

export const ReviewBannerExit = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: #8a6d3b;

  &:hover {
    color: #6b5327;
  }
`
